// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
select,
textarea {
  /* border: 1px solid var(--border-color) !important; */
  border-radius: 6px !important;
  color: var(--input-text-color);
}

label {
  color: var(--input-text-color) !important;
}

.float-label {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 1em;
}

.float-label input,
.float-label select,
.float-label .document-uploader,
.float-label canvas {
  height: 50px;
  padding: 14px 16px 0 10px;
  outline: 0;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: #fff;
  font-size: 16px;
}

.float-label textarea {
  padding: 14px 16px 0 10px;
  outline: 0;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: #fff;
  font-size: 16px;
}

.float-label select {
  width: 100%;
}

.float-label label {
  font-size: 11px;
  padding: 3px 12px;
  color: #999;
  pointer-events: none;

  position: absolute;
}

.float-label .PhoneInput {
  background: white;
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.float-label .PhoneInput input {
  border: none !important;
}

.video-frame {
  width: 100%;
  height: 8em;
}

.PhoneInputCountry {
  top: 8px;
  left: 8px;
}

.document-field {
  display: none;
}
.document-field button {
  background-color: aqua;
}

.document-uploader button {
  float: right;
  color: white;
  background: var(--primary-color);
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  position: relative;
  top: -6px;
}

.document-uploader p {
  float: left;
}

.signature canvas {
  height: 10em;
}

.clear-signature,
.upload-signature {
  margin-top: 1em;
  width: 20%;
  padding: 0.5em 2em;
  border: 0;
  border-radius: 6px;
  background-color: var(--primary-color);
  color: var(--white);
  font-weight: Bold;
}

.clear-signature {
  float: left;
}
.upload-signature {
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/components/input.css"],"names":[],"mappings":"AAAA;;;EAGE,sDAAsD;EACtD,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;;EAEpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd","sourcesContent":["input,\nselect,\ntextarea {\n  /* border: 1px solid var(--border-color) !important; */\n  border-radius: 6px !important;\n  color: var(--input-text-color);\n}\n\nlabel {\n  color: var(--input-text-color) !important;\n}\n\n.float-label {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-top: 1em;\n}\n\n.float-label input,\n.float-label select,\n.float-label .document-uploader,\n.float-label canvas {\n  height: 50px;\n  padding: 14px 16px 0 10px;\n  outline: 0;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  background: #fff;\n  font-size: 16px;\n}\n\n.float-label textarea {\n  padding: 14px 16px 0 10px;\n  outline: 0;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  background: #fff;\n  font-size: 16px;\n}\n\n.float-label select {\n  width: 100%;\n}\n\n.float-label label {\n  font-size: 11px;\n  padding: 3px 12px;\n  color: #999;\n  pointer-events: none;\n\n  position: absolute;\n}\n\n.float-label .PhoneInput {\n  background: white;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n}\n\n.float-label .PhoneInput input {\n  border: none !important;\n}\n\n.video-frame {\n  width: 100%;\n  height: 8em;\n}\n\n.PhoneInputCountry {\n  top: 8px;\n  left: 8px;\n}\n\n.document-field {\n  display: none;\n}\n.document-field button {\n  background-color: aqua;\n}\n\n.document-uploader button {\n  float: right;\n  color: white;\n  background: var(--primary-color);\n  border: none;\n  border-radius: 4px;\n  padding: 4px 8px;\n  position: relative;\n  top: -6px;\n}\n\n.document-uploader p {\n  float: left;\n}\n\n.signature canvas {\n  height: 10em;\n}\n\n.clear-signature,\n.upload-signature {\n  margin-top: 1em;\n  width: 20%;\n  padding: 0.5em 2em;\n  border: 0;\n  border-radius: 6px;\n  background-color: var(--primary-color);\n  color: var(--white);\n  font-weight: Bold;\n}\n\n.clear-signature {\n  float: left;\n}\n.upload-signature {\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
